import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { DateTime } from 'luxon';

export const DATE_FORMAT_PROGRESS_BAR = 'dd LLLL, yyyy - HH:mm';
export const DATE_FORMAT_PROGRESS_BAR_SHORT = 'dd LLL, yyyy - HH:mm';

@Pipe({
    name: 'formatDate',
})
export class FormatDatePipe implements PipeTransform {
    transform(value: unknown, args: string | null = null): string {
        let datetime: any = DateTime.now();

        if (_.isString(value)) {
            datetime = DateTime.fromISO(value);
        }

        if (_.isDate(value)) {
            datetime = DateTime.fromJSDate(value);
        }

        if (!datetime.isValid) {
            return '-';
        }

        if (args !== null) {
            return datetime.toFormat(args);
        }

        return datetime.toString();
    }
}
